module.exports = __webpack_public_path__ + "img/sign.04b6ff2f.png";